/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientImages/view.blocks to change it.
import AllImages from './AllImages/index'
import Preview from './Preview/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientImages({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Gallery/Content/PatientImages"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="PatientImages.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AllImages
  viewPath={`${viewPath}/AllImages`}
/>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</div>
{children}
</React.Fragment>)
}